import ExtensionAPI from "@cbook/shared/apiV3/ExtensionAPI";
import ExtensionBridge from "./ExtensionBridge";
var api = new ExtensionAPI(ExtensionBridge);
window.__ExtensionAPI = api;
export default api;
